import * as types from "./strategiccapacityactionType";

// strategic demand dropdown
export const fetchBlockDemandPlanningReportsDDRequest = () => ({
  type: types.FETCH_BLOCK_DEMAND_PLANNING_REPORTS_DD_REQUEST
});

export const fetchBlockDemandPlanningReportsDDSuccess = (payload) => ({
  type: types.FETCH_BLOCK_DEMAND_PLANNING_REPORTS_DD_SUCCESS,
  payload
});

export const fetchBlockDemandPlanningReportsDDFailure = (error) => ({
  type: types.FETCH_BLOCK_DEMAND_PLANNING_REPORTS_DD_FAILURE,
  error
});
// strategic capacity table
export const fetchAllReportsPaginationRequest = (payload) => ({
  type: types.FETCH_ALL_REPORTS_PAGINATION_REQUEST,
  payload
});

export const fetchAllReportsPaginationSuccess = (payload) => ({
  type: types.FETCH_ALL_REPORTS_PAGINATION_SUCCESS,
  payload,
});


export const fetchAllReportsPaginationFailure = (error) => ({
  type: types.FETCH_ALL_REPORTS_PAGINATION_FAILURE,
  error
});

export const deleteCapacityReportRequest = (id) => ({
  type: types.DELETE_STRATEGIC_CAPACITY_REPORT_REQUEST,
  payload: id,
});

export const deleteCapacityReportSuccess = () => ({
  type: types.DELETE_STRATEGIC_CAPACITY_REPORT_SUCCESS,
});

export const deleteCapacityReportFailure = (error) => ({
  type: types.DELETE_STRATEGIC_CAPACITY_REPORT_FAILURE,
  error,
});
// strategiccapacityaction.js
export const exportCapacityReportRequest = (payload) => ({
  type: types.EXPORT_CAPACITY_REPORT_REQUEST,
  payload,
});
export const exportCapacityReportSuccess = (payload) => ({
  type: types.EXPORT_CAPACITY_REPORT_SUCCESS,
  payload,
});
export const exportCapacityReportFailure = (error) => ({
  type: types.EXPORT_CAPACITY_REPORT_FAILURE,
  error,
});
// strategiccapacityaction.js
export const fetchBlockCapacityTableRequest = (payload) => ({
  type: types.FETCH_BLOCK_CAPACITY_TABLE_REQUEST,
  payload,
});

export const fetchBlockCapacityTableSuccess = (payload) => ({
  type: types.FETCH_BLOCK_CAPACITY_TABLE_SUCCESS,
  payload,
});

export const fetchBlockCapacityTableFailure = (error) => ({
  type: types.FETCH_BLOCK_CAPACITY_TABLE_FAILURE,
  error,
});
// strategiccapacityaction.js
export const fetchCapacityTableReportRequest = (payload) => ({
  type: types.FETCH_CAPACITY_TABLE_REPORT_REQUEST,
  payload,
});

export const fetchCapacityTableReportSuccess = (payload) => ({
  type: types.FETCH_CAPACITY_TABLE_REPORT_SUCCESS,
  payload,
});

export const fetchCapacityTableReportFailure = (error) => ({
  type: types.FETCH_CAPACITY_TABLE_REPORT_FAILURE,
  error,
});
// strategiccapacityaction.js
export const fetchReportNoteRequest = (payload) => ({
  type: types.FETCH_REPORT_NOTE_REQUEST,
  payload,
});

export const fetchReportNoteSuccess = (payload) => ({
  type: types.FETCH_REPORT_NOTE_SUCCESS,
  payload,
});

export const fetchReportNoteFailure = (error) => ({
  type: types.FETCH_REPORT_NOTE_FAILURE,
  error,
});

export const updateReportNoteRequest = (payload) => ({
  type: types.UPDATE_REPORT_NOTE_REQUEST,
  payload,
});

export const updateReportNoteSuccess = () => ({
  type: types.UPDATE_REPORT_NOTE_SUCCESS,
});

export const updateReportNoteFailure = (error) => ({
  type: types.UPDATE_REPORT_NOTE_FAILURE,
  error,
});
// strategiccapacityaction.js
export const fetchCapacityDailyViewRequest = (payload) => ({
  type: types.FETCH_CAPACITY_DAILY_VIEW_REQUEST,
  payload,
});

export const fetchCapacityDailyViewSuccess = (payload) => ({
  type: types.FETCH_CAPACITY_DAILY_VIEW_SUCCESS,
  payload,
});

export const fetchCapacityDailyViewFailure = (error) => ({
  type: types.FETCH_CAPACITY_DAILY_VIEW_FAILURE,
  error,
});
export const fetchCapacityQuarterlyViewRequest = (payload) => ({
  type: types.FETCH_CAPACITY_QUARTERLY_VIEW_REQUEST,
  payload,
});

export const fetchCapacityQuarterlyViewSuccess = (data) => ({
  type: types.FETCH_CAPACITY_QUARTERLY_VIEW_SUCCESS,
  payload: data,
});

export const fetchCapacityQuarterlyViewFailure = (error) => ({
  type: types.FETCH_CAPACITY_QUARTERLY_VIEW_FAILURE,
  error,
});

// strategiccapacityaction.js
export const fetchCapacityFilterDDRequest = () => ({
  type: types.FETCH_CAPACITY_FILTER_DD_REQUEST,
});

export const fetchCapacityFilterDDSuccess = (payload) => ({
  type: types.FETCH_CAPACITY_FILTER_DD_SUCCESS,
  payload,
});

export const fetchCapacityFilterDDFailure = (error) => ({
  type: types.FETCH_CAPACITY_FILTER_DD_FAILURE,
  error,
});
export const fetchWorklistByRPCERequest = (rpceID) => ({
  type: types.FETCH_WORKLIST_BY_RPCE_REQUEST,
    payload: rpceID,
});

export const fetchWorklistByRPCESuccess = (data) => ({
  type: types.FETCH_WORKLIST_BY_RPCE_SUCCESS,
    payload: data
});

export const fetchWorklistByRPCEFailure = (error) => ({
  type: types.FETCH_WORKLIST_BY_RPCE_FAILURE,
  error,
});
export const fetchOnboardingSiteLegendRequest = () => ({
  type: types.FETCH_ONBOARDING_SITE_LEGEND_REQUEST,
});

export const fetchOnboardingSiteLegendSuccess = (payload) => ({
  type: types.FETCH_ONBOARDING_SITE_LEGEND_SUCCESS,
  payload,
});

export const fetchOnboardingSiteLegendFailure = (error) => ({
  type: types.FETCH_ONBOARDING_SITE_LEGEND_FAILURE,
  error,
});
// strategiccapacityaction.js
export const draftCapacityTableRequest = (payload) => ({
  type: types.DRAFT_CAPACITY_TABLE_REQUEST,
  payload,
});

export const draftCapacityTableSuccess = () => ({
  type: types.DRAFT_CAPACITY_TABLE_SUCCESS,
});

export const draftCapacityTableFailure = (error) => ({
  type: types.DRAFT_CAPACITY_TABLE_FAILURE,
  error,
});

export const publishCapacityTableRequest = (payload) => ({
  type: types.PUBLISH_CAPACITY_TABLE_REQUEST,
  payload,
});

export const publishCapacityTableSuccess = () => ({
  type: types.PUBLISH_CAPACITY_TABLE_SUCCESS,
});

export const publishCapacityTableFailure = (error) => ({
  type: types.PUBLISH_CAPACITY_TABLE_FAILURE,
  error,
});
// strategiccapacity cascading WeekQuarterByMonthYear
export const fetchWeekQuarterByMonthYearRequest = (payload) => ({
  type: types.FETCH_WEEK_QUARTER_BY_MONTH_YEAR_REQUEST,
  payload,
});

export const fetchWeekQuarterByMonthYearSuccess = (payload) => ({
  type: types.FETCH_WEEK_QUARTER_BY_MONTH_YEAR_SUCCESS,
  payload,
});

export const fetchWeekQuarterByMonthYearFailure = (error) => ({
  type: types.FETCH_WEEK_QUARTER_BY_MONTH_YEAR_FAILURE,
  error,
});
